import { useEffect, useState } from "react";
import { FileDown } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { api, fmtDate, fmtDuration } from "@/lib/api";
import { PageHeader } from "@/components/PageHeader";

export default function History() {
  const [rows, setRows] = useState([]);
  const [groups, setGroups] = useState({});

  useEffect(() => {
    api.get("/history").then(({ data }) => setRows(data));
    api.get("/groups").then(({ data }) => setGroups(Object.fromEntries(data.map((g) => [g.group_id, g.name]))));
  }, []);

  const exportCsv = () => {
    const head = "Début;Fin;Durée (s);Technicien;Machine;Client";
    const lines = rows.map((r) => [r.started_at, r.ended_at || "", r.duration_s ?? "", r.user_name, r.hostname, groups[r.group_id] || ""].join(";"));
    const blob = new Blob(["\ufeff" + [head, ...lines].join("\n")], { type: "text/csv" });
    const a = document.createElement("a");
    a.href = URL.createObjectURL(blob);
    a.download = "historique-connexions.csv";
    a.click();
  };

  return (
    <div className="flex-1 overflow-y-auto px-6 lg:px-10 py-8">
      <PageHeader kicker="AUDIT" title="Historique des connexions">
        <Button variant="secondary" onClick={exportCsv} data-testid="export-history-btn" disabled={!rows.length}>
          <FileDown className="h-4 w-4 mr-1.5" /> Exporter CSV
        </Button>
      </PageHeader>
      <div className="rounded-lg border border-slate-200 bg-white">
        <Table data-testid="history-table">
          <TableHeader>
            <TableRow>
              <TableHead>Début</TableHead>
              <TableHead>Technicien</TableHead>
              <TableHead>Machine</TableHead>
              <TableHead>Client</TableHead>
              <TableHead className="text-right">Durée</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {rows.map((r) => (
              <TableRow key={r.history_id} data-testid={`history-row-${r.history_id}`}>
                <TableCell className="font-mono text-xs">{fmtDate(r.started_at)}</TableCell>
                <TableCell>{r.user_name}</TableCell>
                <TableCell className="font-semibold">{r.hostname}</TableCell>
                <TableCell className="text-slate-500">{groups[r.group_id] || "Non classé"}</TableCell>
                <TableCell className={`text-right font-mono text-xs ${r.ended_at ? "" : "text-amber-600"}`}>{fmtDuration(r.duration_s)}</TableCell>
              </TableRow>
            ))}
            {!rows.length && (
              <TableRow><TableCell colSpan={5} className="text-center text-slate-500 py-10">Aucune connexion enregistrée.</TableCell></TableRow>
            )}
          </TableBody>
        </Table>
      </div>
    </div>
  );
}
